
        import '/home/builduser/work/5d4c7c61b0622e62/santa-editor/packages/topBar/limitlessZoom/limitlessZoomMenu.scss.css.virtualfile';
        module.exports = {"divider":"_divider_xy6vv_1","menuRow":"_menuRow_xy6vv_4","shortcut":"_shortcut_xy6vv_12"};